import { render, staticRenderFns } from "./putIn.vue?vue&type=template&id=d38597ea&scoped=true&"
import script from "./putIn.vue?vue&type=script&lang=js&"
export * from "./putIn.vue?vue&type=script&lang=js&"
import style0 from "./putIn.vue?vue&type=style&index=0&id=d38597ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38597ea",
  null
  
)

export default component.exports